import { BRAND, GRAY, GRAY_DARK, GRAY_LIGHT } from "../colors";
import componentSizes from "../constants/componentSizes";

const colors = {
  BRAND,
  GRAY,
  GRAY_DARK,
  GRAY_LIGHT
};

const orientations = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
};

/**
 * @deprecated please use @streeteasy/design-system/constants/componentSizes instead
 */
const sizes = {
  MD: componentSizes.MD,
  LG: componentSizes.LG
};

export { colors, orientations, sizes };
